export EmailDetails from './email-details';
export CallDetails from './call-details';
export MonitoringAlertDetails from './monitoring-alert-details';
export Answer from './answer';
export Transfer from './transfer';
export SendToInbox from './send-to-inbox';
export Claim from './claim';
export AddToTicket from './add-to-ticket';
export ResolveWithTime from './resolve-with-time';
export Resolve from './resolve';
export Archive from './archive';
export PullIntoTicket from './pull-into-ticket';



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/index.js